import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { ColorPicker } from 'components';
import { SectionHeading } from '../../styles';

const ShapeColor = ({ initialColor, pickColor }) => (
  <Fragment>
    <SectionHeading>Boundary Colour</SectionHeading>
    <ColorPicker initialColor={initialColor} pickColor={pickColor} />
  </Fragment>
);

ShapeColor.propTypes = {
  pickColor: PropTypes.func.isRequired,
  initialColor: PropTypes.string.isRequired,
};

export default React.memo(ShapeColor);
